export const questions = {
	periodsSelect: {
		select: '.js-periods-select',
	},
}
